import React, { createContext, useContext, useState, useEffect } from 'react';

const MobileContext = createContext({
	isMobile: false,
	windowInnerWidth: 0,
});

const MobileProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
	const mobileThreshold = 1000;

	const [isMobile, setIsMobile] = useState<boolean>(false);
	const [windowInnerWidth, setWindowInnerWidth] = useState<number>(0);

	useEffect((): (() => void) => {
		const handleResize = (): void => {
			setIsMobile(window.innerWidth < mobileThreshold);
			setWindowInnerWidth(window.innerWidth);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return <MobileContext.Provider value={{ isMobile, windowInnerWidth }}>{children}</MobileContext.Provider>;
};

const useMobileContext = (): { isMobile: boolean; windowInnerWidth: number } => {
	const context = useContext(MobileContext);
	if (context === undefined) {
		throw new Error('useMobileContext must be used within a MobileProvider');
	}
	return context;
};

export { MobileProvider, useMobileContext };
